import http from '@/biz/http.mjs'
import {writeFileToDisk} from '@/script/file.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonExportSpec(props) {
    const map = useMapContext()
    const {mapStsCode, mapTypeCode} = map.useMetaData()

    const createOnClick = specLevel =>
        async () => {
            const {
                bdCode,
                bizNodeType,
                isrfCode,
                prjId,
                sVer,
                uiCode,
            } = map.root.data

            const [dpCode, url] = {
                BD: [bdCode, '/ide/exportSpecByBd'],
                ISRF: [isrfCode, '/ide/exportSpecByIsrf'],
                UI: [uiCode, '/ide/exportSpecByUi'],
            }[bizNodeType]

            const {blob, fileName} = await runAsync(
                () => http.post(url, {dpCode, prjId, specLevel, sVer}),
                {action: '导出Spec'}
            )

            writeFileToDisk(blob, {suggestedName: fileName})
        }

    if ('_BD_MAP' === mapTypeCode) {
        const items = [
            {
                label: '导出Spec2',
                onClick: createOnClick(2),
            },

            {
                label: '导出Spec3',
                onClick: createOnClick(3),
            },
        ]

        return (
            <MenuButton
                items={items}
                {...props}
            >
                导出Spec
            </MenuButton>
        )
    }
    else if ('_ISRF_MAP' === mapTypeCode) {
        if ('RLS' === mapStsCode) {
            const items = [
                {
                    label: '导出Spec1',
                    onClick: createOnClick(1),
                },

                {
                    label: '导出Spec2',
                    onClick: createOnClick(2),
                },

                {
                    label: '导出Spec3',
                    onClick: createOnClick(3),
                },
            ]

            return (
                <MenuButton
                    items={items}
                    {...props}
                >
                    导出Spec
                </MenuButton>
            )
        }
        else {
            return null
        }
    }
    else if ('_UI_MAP' === mapTypeCode) {
        const items = [
            {
                label: '导出Spec1',
                onClick: createOnClick(1),
            },

            {
                label: '导出Spec2',
                onClick: createOnClick(2),
            },

            {
                label: '导出Spec3',
                onClick: createOnClick(3),
            },
        ]

        return (
            <MenuButton
                items={items}
                {...props}
            >
                导出Spec
            </MenuButton>
        )
    }
    else {
        return null
    }
}
